import { render } from "./EntityPolicyInventory.vue?vue&type=template&id=9673272c&scoped=true"
import script from "./EntityPolicyInventory.vue?vue&type=script&lang=js"
export * from "./EntityPolicyInventory.vue?vue&type=script&lang=js"

import "./EntityPolicyInventory.vue?vue&type=style&index=0&id=9673272c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9673272c"]])

export default __exports__